import { get } from "@/api/implementation/app";

export default async function (fileUrl, fileName) {
    const response = await get(fileUrl, {
        responseType: "blob",
    });

    const contentType = response.headers["content-type"] || "application/pdf";
    const blob = new Blob([response.data], {
        type: contentType,
    });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(url);
}
